export default __webpack_public_path__ + "img/12.b15c7805.jpg";